import React, { useState } from "react";
import Header from './Header';
import '../styles/manpowerlist.css'

const ManpowerList = () => {

    const salaryData = [
        {
          project: "E-commerce App",
          subcategory: "Development",
          totalPresentDays: "10",
          totalOtTime: "10h",
          totalOtSalary: "$500",
          overAllSalary: "$5000"
        },
        {
          project: "CRM System",
          subcategory: "QA Testing",
          totalPresentDays: "10",
          totalOtTime: "8h",
          totalOtSalary: "$400",
          overAllSalary: "$4500"
        },
        {
          project: "Banking Software",
          subcategory: "UI/UX Design",
          totalPresentDays: "10",
          totalOtTime: "12h",
          totalOtSalary: "$600",
          overAllSalary: "$5500"
        },
        {
          project: "Healthcare Platform",
          subcategory: "Backend Development",
          totalPresentDays: "10",
          totalOtTime: "15h",
          totalOtSalary: "$750",
          overAllSalary: "$6000"
        }
      ];
      

    return (
        <div className="manpowerList">
            <div className="headerdetails">
                <h2>All salary data</h2>
                <div className="actionsdesign">
                    <button className="selectdate">Select date</button>
                    <h3>Sort by :</h3>
                    <div className="dropdown">
                        <select id="options" className="dropdown-select">
                            <option value="option1">Option 1</option>
                            <option value="option2">Option 2</option>
                            <option value="option3">Option 3</option>
                        </select>
                    </div>
                    <button className="addbtn">Add new</button>
                </div>
            </div>

            <table className="salarytable">
                <thead>
                    <tr>
                        <th>S.NO</th>
                        <th>PROJECT</th>
                        <th>SUB CATEGORY</th>
                        <th>TOTAL PRESENT DAYS</th>
                        <th>TOTAL O.T TIME</th>
                        <th>TOTAL O.T SALARY</th>
                        <th>OVERALL SALARY</th>
                    </tr>
                </thead>
                <tbody>
                    {salaryData.map((employee,index)=>(
                        <tr key={index}>
                            <td>{index+1}</td>
                            <td>{employee.project}</td>
                            <td>{employee.subcategory}</td>
                            <td>{employee.totalPresentDays}</td>
                            <td>{employee.totalOtTime}</td>
                            <td>{employee.totalOtSalary}</td>
                            <td>{employee.overAllSalary}</td>
                        </tr>
                    ))}
                </tbody>

            </table>

        </div>
    )
};
export default ManpowerList;